import { render, staticRenderFns } from "./HomeLaudos.vue?vue&type=template&id=2d283734&lang=true&"
import script from "./HomeLaudos.vue?vue&type=script&lang=js&"
export * from "./HomeLaudos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports